import React from 'react';
import { StyledCorporateValue } from '@/components/common/ygen/sections/corporate-value/corporate-value.style';
import { Col, Container, Row } from 'react-bootstrap';
import reactHtmlParser from 'react-html-parser';
import Title from '@/components/common/ui/text/Title';
import useContainerOffset from '@/components/hooks/useContainerOffset';

const Overview = ({ data, id }) => {
	const offset = useContainerOffset('.container')
	return (
		<StyledCorporateValue style={{marginRight: offset+15+'px', paddingLeft: offset+15+'px'}} data-scroll-section id={`${id ? id : 'core-value'}`} className="pt-200 pb-200 horizontal-scroll" data-speed-right={50} data-speed-left={-50}>

			<Container>
				<Row>
					<Col lg={{ span: 8 }} className={'mb80'}>
						{
							data?.section_data?.subtitle &&
							<Title animClass={'fade-up'} tag={'h2'} margin={'0 0 40px'} text={data?.section_data?.subtitle} color={'#fff'} />

						}
						{
							data?.section_data?.short_desc &&
							<p className={'fade-up'} >{reactHtmlParser(data?.section_data?.short_desc)}</p>

						}
					</Col>

					<Col lg={{ span: 9, offset: 2 }}>
						<Row className={'m-0'}>
							{data?.posts?.list?.length > 0 && data?.posts?.list?.map((item, index) => (
								<Col lg={6} className={'counter-item'} key={index}>
									{item?.data?.title && <h4 className={'fade-up'} data-scroll data-scroll-repeat>{reactHtmlParser(item?.data?.title)}</h4>}
									{item?.data?.description && <p className={'fade-up'} data-scroll data-scroll-repeat>{reactHtmlParser(item?.data?.description)}</p>}
								</Col>
							))}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </StyledCorporateValue>
	);
};


export default Overview;
